/** Horizontal spacing between nodes in workflow diagram (pixels) */
export const NODE_X_SPACING = 200;

/** Fixed width of condition/action nodes (pixels) */
export const NODE_WIDTH = 350;

/** Size of the add-step button (pixels) */
export const ADD_STEP_SIZE = 32;

/** Vertical gap between nodes (pixels) */
export const NODE_Y_GAP = 80;

/** Default node height for unmeasured nodes (pixels) */
export const DEFAULT_NODE_HEIGHT = 100;

/** End node horizontal offset (pixels) */
export const END_NODE_OFFSET_X = -6;

/** End node vertical offset from last add-step button (pixels) */
export const END_NODE_OFFSET_Y = 10;

/** @deprecated Use NODE_Y_GAP instead */
export const ADD_STEP_GAP = NODE_Y_GAP;

/** Allowlisted `customViewKey` for Notify User (client default; server may send the same value). */
export const WORKFLOW_NOTIFY_USER_CUSTOM_VIEW_KEY = "WorkflowNotifyUser";
